var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"5.8.6"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";
import { httpClientIntegration } from "@sentry/integrations";

import { QUINE_APP_VERSION } from "./src/constants/common";
import { getEnvironmentTag } from "./src/utils/errorReporter";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate:
    Date.now() < new Date("2023-09-26T00:00:00Z").getTime() ? 0.1 : 0.01,
  enabled: process.env.NODE_ENV === "production",
  environment: getEnvironmentTag(),
  release: QUINE_APP_VERSION,
  allowUrls: [/https?:\/\/((staging|dev)\.)?quira\.sh/],
  denyUrls: [/https?:\/\/((staging|dev)\.)?quira\.sh\/s\/dl\.js/],
  ignoreErrors: [
    "TypeError: Failed to fetch",
    "TypeError: NetworkError when attempting to fetch resource.",
    "TypeError: cancelled",
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
  ],
  initialScope: (scope) => {
    scope.setTag("version", QUINE_APP_VERSION);
    return scope;
  },
  integrations: [
    httpClientIntegration({
      failedRequestStatusCodes: [400, [500, 599]],
    }),
  ],
});
